export default class Provisioning
{
    
    constructor( core )
    {
        
        if ( !Provisioning.instance ) {
            
            this.logger = core.getLogger()
            this.eventManager = core.getEventManager()
            this.store = core.getStore()
            this.client = core.getWebsockets()
            this.eventManager = core.getEventManager()
            
            this.eventManager.add( 'on-sockets-ready', () =>
            {
                this.client = core.getWebsockets()
                this.readStore()
                this.initialize()
            } )
            
            this.logger.cconstructed( 'Provisioning', 'initializing' )
            
            this.state = 'initializing'
            
            this.serial = null
            this.localUrl = null
            this.remoteUrl = null
            this.privateKeyUint = null
            
            Provisioning.instance = this
            
        }
        
        return Provisioning.instance
        
    }
    
    initialize()
    {
        
        this.client.request( {
            method: 'endpoint.getPublicKey'
        }, 'local' ).then( response =>
            {
                if ( undefined !== response && undefined !== response.publicKey ) {
                    this.eventManager.dispatch( 'on-public-key-update', response.publicKey )
                    
                }
            } )
            .catch( () =>
            {
            } )
        
        this.client.request( {
            method:       'proxy.getPublicKey',
            looseSession: true
        }, 'remote' ).then( response =>
        {
            if ( undefined !== response && undefined !== response.publicKey ) {
                this.eventManager.dispatch( 'on-proxy-key-update', response.publicKey )
            }
        } ).catch( () =>
        {
        } )
        
    }
    
    readStore()
    {
        this.serial = this.store.getters.serial
        this.eventManager.dispatch( 'on-serial-update', this.serial )
    }
    
    storeSetup( keyStore )
    {
        return new Promise( ( resolve, reject ) =>
        {
            
            let setup     = JSON.parse( keyStore.setup ),
                localUrl  = setup.localAddress,
                remoteUrl = setup.remoteAddress
            
            this.serial = setup.user
            this.localUrl = localUrl
            this.remoteUrl = remoteUrl
            this.privateKeyUint = keyStore.privateKey
            
            this.store.commit( 'setSerial', this.serial )
            this.store.commit( 'setLocalUrl', this.localUrl )
            this.store.commit( 'setRemoteUrl', this.remoteUrl )
            
            this.store.commit( 'setEncryptedPrivateKey', keyStore.keys.private )
            this.store.commit( 'setPublicKey', keyStore.keys.public )
            
            this.eventManager.dispatch( 'on-keyring-update' )
            this.eventManager.dispatch( 'on-serial-update', this.serial )
            
            return resolve()
            
        } )
        
    }
    
}